var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

window.BOOM = window.BOOM || {};
window.BOOM.Product = function(el, product) {
  this.el = el;
  this.$el = $(el);
  this.product = product;
  
  this.init();
  
  this.updatePrice();
  this.updateAddToCartBtn();
  
  //remove after ab test
//   this.tryReplaceProductIfNeeded();
  this.showPrice();
  
};

window.BOOM.Product.prototype = {
  init: function() {
    this.$el.find('[data-quantity-selector]').on('change', this.onQuantityChange.bind(this));
    this.$el.find('[data-variant]').on('change', this.onVariantChange.bind(this));
    this.$el.find('[data-add-to-cart-btn]').on('click', this.onAddToCartBtnClick.bind(this));

    this.$el.find('[data-quantity-selector-up]').on('click', this.onQuantityUp.bind(this));
    this.$el.find('[data-quantity-selector-down]').on('click', this.onQuantityDown.bind(this));
    document.addEventListener('boomProductQuantityChange', this.onQuantityChangeOutside.bind(this));
    this.showFirstVariant();
  },

  onQuantityChangeOutside: function(event) {
    var productOptions = this.getProductOptions();
    productOptions.quantity = event.detail.quantity;
    this.setProductOptions(productOptions);
  },
  
  onQuantityUp: function() {
    // this.$el.find('[data-quantity-selector]')[0].stepUp();
      this.$el.find('[data-quantity-selector ]')[0].value = Number(this.$el.find('[data-quantity-selector]')[0].value) + 1;

    this.onQuantityChange();
  }, 
  
  onQuantityDown: function() {
      // this.$el.find('[data-quantity-selector]')[0].stepDown();

      this.$el.find('[data-quantity-selector ]')[0].value = Number(this.$el.find('[data-quantity-selector]')[0].value) - 1;

      this.onQuantityChange();
  }, 


  onQuantityChange: function() {
if (this.$el.find('[data-quantity-selector]')[0].value.length < 1 ) {
  this.$el.find('[data-quantity-selector]')[0].value = 1
}
    this.triggerChangeProductEvent();
  },

  triggerChangeProductEvent: function() {
    var productOptions = this.getProductOptions();
    this.onProductOptionsChange(productOptions);
    var changeEvent = new CustomEvent('boomProductChange', { detail: productOptions });
    document.dispatchEvent(changeEvent);
  },
    updateVariantValue: function() {
        var productOptions = this.getProductOptions();
        this.$el.find('[data-form-field]').val(productOptions.variantId);
        console.log(productOptions.variantId)
    },

  onVariantChange: function() {
    this.triggerChangeProductEvent();
    this.updatePrice();
    this.updateAddToCartBtn();
    this.updateVariantValue();
  },

  getProductOptions: function() {
    return {
      quantity: this.$el.find('[data-quantity-selector]').val(),
      variantId: this.$el.find('[data-variant]:checked').val()
    };
  },
    getVariantOptions: function() {
        return {
            variantId: this.$el.find('[data-variant]:checked').val()
        };
    },

  setProductOptions: function(options) {

    this.$el.find('[data-quantity-selector]').val(options.quantity);
    this.$el.find('[data-variant="' + options.variantId + '"]').prop('checked', true);
	
    this.updatePrice();
    this.updateAddToCartBtn();
    this.showSoldOutText()
  },

  onProductOptionsChange: function() {},

  showSoldOutText: function() {
    var prOps = this.getProductOptions();
    var variant = this.getVariantById(prOps.variantId);
    var isAddToCartActive = !variant || variant.available;
    if (!isAddToCartActive) {
      $('.bbc-soldout-link').addClass('sold-out')
    } else {
      $('.bbc-soldout-link').removeClass('sold-out')
    }
  },

   getVariantById: function(id) {
    var variants = this.product.variants;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id == id) {
        return variants[i];
      }
    }

    return null;
  },
  
  getFirstAvailableVariant: function() {
  	var variants = this.product.variants;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) {
        return variants[i];
      }
    }

    return null;
  },
  
  showFirstVariant: function() {
  	var variant = this.getFirstAvailableVariant();
    if (!variant) {
    	variant = this.product.variants[0];
    }
    
    this.setProductOptions({
      	quantity: 1,
    	variantId: variant.id
    });
  },

  updatePrice: function() {
    var productOptions = this.getProductOptions();
    var variant = this.getVariantById(productOptions.variantId);

    if (variant) {
      this.renderPrice(variant.price);
      this.$el.find('[data-product-price]').text(Shopify.formatMoney(variant.price, '${{amount_no_decimals}}'));
    }
  },
  
  renderPrice: function(price) {
    this.$el.find('[data-product-price]')
    .text(Shopify.formatMoney(price, '${{amount_no_decimals}}'))
    .show();
  },
  
  showPrice: function(price) {
  	this.$el.find('[data-product-price]').show().css('visibility', 'visible');
  },
  
  updateAddToCartBtn: function() {
  	var prOps = this.getProductOptions();
    var variant = this.getVariantById(prOps.variantId);
    var btn = this.el.querySelector('[data-add-to-cart-btn]');
    var btnUp = this.el.querySelector('[data-quantity-selector-up]');
    var btnDown = this.el.querySelector('[data-quantity-selector-down]');
    var quatitySelector = this.el.querySelector('[data-quantity-selector]');
    var isAddToCartActive = !variant || variant.available;
    var dataQuantity = this.el.querySelector('[data-quantity-battons]');
    
    if (btn) {
      	btn.innerHTML = isAddToCartActive ? 'Add to Bag' : 'Sold Out';
    	btn.disabled = !isAddToCartActive;
    }
    
    if (quatitySelector) {
      	quatitySelector.disabled = !isAddToCartActive;
        // quatitySelector.hidden = !isAddToCartActive;
    }
      if (btnUp || btnDown) {
          btnUp.disabled = !isAddToCartActive;
          btnDown.disabled = !isAddToCartActive;
        // dataQuantity.hidden = !isAddToCartActive;
      }
      
  },
  
  onAddToCartBtnClick: function(e) {
    var qnttyVal = this.$el.find('[data-quantity-selector]').val();
    
    if ( qnttyVal == "") {
        e.preventDefault();
    } 
    if (window.BOOM.cartMode == 'sidebar') {
      e.preventDefault();
      var ops = this.getProductOptions();
      window.BOOM.cart.addVariant(ops.variantId, ops.quantity);
    }
  },
  
 
   //========================remove after ab test(start)=========================================
      tryReplaceProductIfNeeded: function() {

        var productReplaceSet = this.getCookie('productReplaceSet');
        var table = this.buildReplaceProductTable(productReplaceSet);

        for (var i = 0; i < table.length; i++) {
          var row = table[i];
          if (this.product.id == row.prod) {
          	 var product = window.BOOM.productsCollection.getProductById(row.replaceWith);
             this.replaceProductWith(product);

             break;
          }
        }

      },

      buildReplaceProductTable: function(replacementVariant) {
        var table = [];

          if (replacementVariant == 'var1') {
              table = [
                  {prod: 1723287535731, replaceWith: 2017597980787}, // Color
                  {prod: 1723287109747, replaceWith: 2017598865523}, // Glimmer
                  {prod: 1723287339123, replaceWith: 2017599357043}, // Glo
                  {prod: 1723286913139, replaceWith: 2017599979635}  // Trio
              ];
          }  else if (replacementVariant == 'var2') {
              table = [
                  {prod: 1723287535731, replaceWith: 2017598374003}, // Color
                  {prod: 1723287109747, replaceWith: 2017598603379}, // Glimmer
                  {prod: 1723287339123, replaceWith: 2017599717491}, // Glo
                  {prod: 1723286913139, replaceWith: 2017600405619}  // Trio
              ];
          }

        return table;
      },

      replaceProductWith: function(product) {
        this.product = product;

        var variant = this.product.variants[0];

        this.renderPrice(variant.price);
        this.$el.find('[name="id"]').val(variant.id);
      },

      getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
  
  
  
  //========================remove after ab test(end)=========================================
};
